import React from "react";
import "./unsupported.css";
import chromeImg from "./images/chrome-white.png";
import firefoxImg from "./images/ffox-white.png";
import edgeImg from "./images/edge-white.png";
import safariImg from "./images/safari-white.png";

const Unsupported = () => {
  return (
    <div className="unsupported">
      <h1>Browser not supported</h1>
      <p>
        You are using a web browser we do not support. <br />
        For the best user experience, use browsers like Chrome, Safari, Firefox
        and Microsoft Edge.
        <br />
        Internet Explorer (IE) is not supported.
      </p>
      <a
        rel="noopener noreferrer"
        target="_blank"
        href="https://www.google.com/chrome/browser/desktop/"
      >
        <img alt="chrome" src={chromeImg} />
      </a>
      <a
        rel="noopener noreferrer"
        target="_blank"
        href="http://www.mozilla.org/firefox/new/"
      >
        <img alt="firefox" src={firefoxImg} />
      </a>
      <a
        rel="noopener noreferrer"
        target="_blank"
        href="https://www.microsoft.com/software-download/windows10"
      >
        <img alt="edge" src={edgeImg} />
      </a>
      <a
        rel="noopener noreferrer"
        target="_blank"
        href="http://www.apple.com/osx/"
      >
        <img alt="safari" src={safariImg} />
      </a>
    </div>
  );
};

export default Unsupported;
